module.exports = __webpack_public_path__ + "static/velourzebra-f28dab9266bf01a36d01e0e7c2ede4c3.jpeg";